import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { AppShell, type NavItem } from './AppShell'
import { useRouter } from './router'
import { About, Home, Posts } from './routes'

export interface AppProps {
  navItems?: NavItem[]
  children?: ReactNode
  isAuthenticated?: boolean
  onLogout?: () => void
  endSlot?: ReactNode
  brand?: string
}

const AppRoutes = () => {
  const { currentPath } = useRouter()
  if (currentPath === '/posts') {
    return <Posts />
  }
  if (currentPath === '/about') {
    return <About />
  }
  return <Home />
}

export const App = ({
  navItems,
  children,
  isAuthenticated = false,
  onLogout,
  endSlot,
  brand,
}: AppProps) => {
  const { t } = useTranslation('common')
  const resolvedNavItems = navItems ?? [
    { to: '/', label: t('nav.home') },
    { to: '/posts', label: t('nav.posts') },
    { to: '/about', label: t('nav.about') },
  ]

  return (
    <AppShell
      navItems={resolvedNavItems}
      isAuthenticated={isAuthenticated}
      onLogout={onLogout}
      endSlot={endSlot}
      brand={brand}>
      {children ?? <AppRoutes />}
    </AppShell>
  )
}
